const API = process.env.REACT_APP_API_URL;

const authHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

// Resources
export const fetchResources = async (token: string) => {
  const res = await fetch(`${API}/resources`, {
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Failed to fetch resources');
  return res.json();
};

export const fetchAllResources = async (token: string) => {
  const res = await fetch(`${API}/resources/all`, {
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Failed to fetch resources');
  return res.json();
};

export const createResource = async (
  token: string,
  data: {
    title: string;
    filename?: string;
    storageId?: string;
    fileType?: string;
    section: string;
    displayOrder?: number;
    resourceType?: string;
    url?: string;
  }
) => {
  const res = await fetch(`${API}/resources`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to create resource');
  return res.json();
};

export const updateResource = async (
  token: string,
  id: string,
  data: Record<string, unknown>
) => {
  const res = await fetch(`${API}/resources/${id}`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to update resource');
  return res.json();
};

export const deleteResource = async (token: string, id: string) => {
  const res = await fetch(`${API}/resources/${id}`, {
    method: 'DELETE',
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Failed to delete resource');
};

export const reorderResources = async (
  token: string,
  items: { id: string; displayOrder: number }[]
) => {
  const res = await fetch(`${API}/resources/reorder`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify({ items }),
  });
  if (!res.ok) throw new Error('Failed to reorder resources');
};

export const getUploadUrl = async (token: string) => {
  const res = await fetch(`${API}/resources/upload-url`, {
    method: 'POST',
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Failed to get upload URL');
  return res.json();
};

export const getDownloadUrl = async (token: string, storageId: string) => {
  const res = await fetch(`${API}/resources/download/${storageId}`, {
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Failed to get download URL');
  return res.json();
};

// Sections
export const fetchSections = async (token: string) => {
  const res = await fetch(`${API}/resources/sections`, {
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Failed to fetch sections');
  return res.json();
};

export const createSection = async (
  token: string,
  data: { name: string; displayOrder?: number }
) => {
  const res = await fetch(`${API}/resources/sections`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to create section');
  return res.json();
};

export const updateSection = async (
  token: string,
  id: string,
  data: { name?: string; displayOrder?: number }
) => {
  const res = await fetch(`${API}/resources/sections/${id}`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to update section');
  return res.json();
};

export const deleteSection = async (token: string, id: string) => {
  const res = await fetch(`${API}/resources/sections/${id}`, {
    method: 'DELETE',
    headers: authHeaders(token),
  });
  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.message || 'Failed to delete section');
  }
};

export const reorderSections = async (
  token: string,
  items: { id: string; displayOrder: number }[]
) => {
  const res = await fetch(`${API}/resources/sections/reorder`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify({ items }),
  });
  if (!res.ok) throw new Error('Failed to reorder sections');
};
